import { CSSProperties } from 'styled-components'
import { TradeDirection } from '~/components/Exchange/types'
import TokenSelect from '~/components/LimitOrder/components/TokenSelect'
import { TradeTokenSelect } from '../TradeTokenSelect'
import {
  Input,
  InputGroup,
  InputHelpText,
  InputLabel,
  InputRow,
  InputWrapper,
} from './styled'

interface ITradeTokenInput {
  groupStyle?: CSSProperties

  /**
   * Input Label
   */
  label: string

  onChange: React.ChangeEventHandler<HTMLInputElement>
  onFocus?: React.FocusEventHandler<HTMLInputElement>

  /**
   * Input Value Title
   *
   * 添加 title 可以帮助用户查看对应的实际未截断的最终值
   */
  title?: string

  /**
   * Input Value
   */
  value: string

  extra?: React.ReactNode

  direction: TradeDirection

  token: BaseTokenlonToken

  placeholder?: string
}

export const TradeTokenInput: React.FC<ITradeTokenInput> = ({
  groupStyle,
  label,
  onChange,
  onFocus,
  title,
  placeholder,
  value,
  extra,
  token,
}) => {
  return (
    <InputGroup style={groupStyle}>
      <InputLabel>{label}</InputLabel>
      <InputWrapper>
        <TradeTokenSelect token={token} />
        <InputRow>
          <Input
            inputMode="decimal"
            onChange={onChange}
            onFocus={onFocus}
            placeholder={placeholder}
            title={title}
            value={value}
          ></Input>
          {extra}
        </InputRow>
      </InputWrapper>
    </InputGroup>
  )
}
